'use client'

import { PageTracking } from '@/meta/components/page-tracking'
import { HeroUIProvider } from '@heroui/react'
import { ToastProvider } from '@heroui/toast'
import { Locale, NextIntlClientProvider } from 'next-intl'
import { useRegisterSW } from './use-register-sw'
import { WebVitals } from './web-vitals'

export function Providers({
  children,
  locale,
  messages,
}: {
  children: React.ReactNode
  locale: Locale
  messages: Record<string, string>
}) {
  useRegisterSW()
  const toastProvider = <ToastProvider placement='bottom-right' />
  const webVitals = <WebVitals />
  const pageTracking = <PageTracking />
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      timeZone={timeZone}
    >
      <HeroUIProvider>
        {toastProvider}
        {webVitals}
        {pageTracking}
        {children}
      </HeroUIProvider>
    </NextIntlClientProvider>
  )
}
